import React, { Component } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import {
  format_date,
  GET,
  loading,
  Status,
  DateRangePicker,
  Pagination,
  Navbar,
  Select,
  Modal,
} from "../../components/CustomComponent.js";

const PAGE_SIZE = 30;
const AUTO_REFRESH_MS = 30000;
const SLOW_WARN_MS = 1000;
const SLOW_DANGER_MS = 3000;
const COPIED_RESET_MS = 2000;
const CALLBACK_PATH_PREFIX = "/api/callback/";
const SYSTEM_CALLBACK_PATHS = ["re-callback", "settlement"];

const SERVICE_TABS = [
  { key: "", label: "All" },
  { key: "backend", label: "Backend" },
  { key: "api-partner", label: "API Partner" },
  { key: "callback", label: "Callback" },
];
const SERVICE_ICONS = {
  "": "\uf0c9",
  backend: "\uf233",
  "api-partner": "\uf0c1",
  callback: "\uf0e2",
};
const SERVICE_BADGES = {
  backend: { label: "backend", tone: "info" },
  "api-partner": { label: "api partner", tone: "success" },
  callback: { label: "callback", tone: "warning" },
};
const serviceBadge = (service) => {
  const s = SERVICE_BADGES[service] || { label: service || "-", tone: "secondary" };
  return Status(s.label, s.tone);
};

const STATUS_OPTIONS = [
  { value: "", label: "--Select Status--" },
  { value: "2xx", label: "2xx SUCCESS" },
  { value: "4xx", label: "4xx CLIENT ERROR" },
  { value: "401", label: "401 UNAUTHORIZED" },
  { value: "403", label: "403 FORBIDDEN" },
  { value: "404", label: "404 NOT FOUND" },
  { value: "429", label: "429 RATE LIMIT" },
  { value: "5xx", label: "5xx SERVER ERROR" },
];

const today = () => format_date(new Date(), "yyyy-mm-dd", "en");
const toDateParam = (d) => (d ? format_date(d, "yyyy-mm-dd", "en") : "");
// backend บังคับช่วงวันที่เสมอ (ตารางหลายล้านแถว ค้นทั้งตารางไม่ไหว) ต้องตรงกับ LOG_RANGE_LIMITS ฝั่ง backend
// clear วันที่แล้วกดค้น จะถอยเป็น DEFAULT_RANGE_DAYS วันล่าสุดแทนการส่งค่าว่าง
const DEFAULT_RANGE_DAYS = 7;
const MAX_RANGE_DAYS = 31;
const daysAgo = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return format_date(d, "yyyy-mm-dd", "en");
};

const getLogUser = (item) => {
  // api-partner เก็บ user_id เป็น brokers.id เสมอ / backend เก็บได้ทั้ง users, brokers, agents
  if (item.service === "api-partner") {
    return item.broker?.name_en || "-";
  }
  const name =
    item.user?.full_name || item.broker?.name_en || item.agent?.name_en;
  if (name) return name;

  // ไม่มี user: แยกตาม path ว่ามาจาก gateway callback, งานภายในระบบ หรือ auth ไม่ผ่าน
  const path = (item.path || "").split("?")[0];
  if (path.startsWith(CALLBACK_PATH_PREFIX)) {
    const segment = path.slice(CALLBACK_PATH_PREFIX.length).split("/")[0];
    if (SYSTEM_CALLBACK_PATHS.includes(segment)) return "System";
    return segment ? `Gateway: ${segment}` : "Gateway";
  }
  if ([401, 403].includes(Number(item.status_code))) return "Unauthorized";
  return "-";
};

const isSuccessStatus = (code) => String(code ?? "").startsWith("2");

const statusBadge = (code) => {
  if (code === null || code === undefined || code === "") {
    return Status("-", "secondary");
  }
  return isSuccessStatus(code) ? Status(code, "success") : Status(code, "danger");
};

const responseTimeClass = (ms) => {
  const value = Number(ms) || 0;
  if (value >= SLOW_DANGER_MS) return "danger";
  if (value >= SLOW_WARN_MS) return "warn";
  return "";
};

const prettyJson = (raw) => {
  if (raw === null || raw === undefined || raw === "") return "";
  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return String(raw);
  }
};

const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const el = document.createElement("textarea");
    el.value = text;
    el.style.position = "fixed";
    el.style.opacity = "0";
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  }
};

export default class Logs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_search_body: false,
      filter_service: "",
      filter_start_date: today(),
      filter_end_date: today(),
      filter_broker: "",
      filter_status: "",

      auto_refresh: false,

      page: 1,
      data: [],
      data_broker: [],
      loaded: false,
      count: 0,

      modal_detail: false,
      detail: null,
      copied_key: "",
    };
    this.refreshTimer = null;
    this.copiedTimer = null;
  }

  async componentDidMount() {
    loading(false);
    await Promise.all([this.GetBrokers(), this.Get(1)]);
  }

  componentWillUnmount() {
    this.stopAutoRefresh();
    if (this.copiedTimer) clearTimeout(this.copiedTimer);
  }

  startAutoRefresh = () => {
    this.stopAutoRefresh();
    this.refreshTimer = setInterval(() => {
      this.Get(this.state.page, true);
    }, AUTO_REFRESH_MS);
  };

  stopAutoRefresh = () => {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
  };

  toggleAutoRefresh = (enabled) => {
    this.setState({ auto_refresh: enabled }, () => {
      if (enabled) {
        this.startAutoRefresh();
      } else {
        this.stopAutoRefresh();
      }
    });
  };

  GetBrokers = async () => {
    let result = await GET("v1/admin/brokers/options", {
      page_size: 100,
      page: 0,
      data_search: "",
    });
    if (result?.status === true) {
      this.setState({
        data_broker: [
          { value: "", label: "--Select Broker--" },
          ...result.data.map((e) => ({ value: e.uid, label: e.name_en })),
        ],
      });
    }
  };

  Get = async (page, silent = false) => {
    const {
      filter_search,
      filter_search_body,
      filter_start_date,
      filter_end_date,
      filter_service,
      filter_broker,
      filter_status,
    } = this.state;
    if (!silent) loading(true);
    // เลือกวันเดียวใน range picker จะได้ end_date เป็น null ให้ใช้วันเดียวกับ start
    let start_date = toDateParam(filter_start_date);
    let end_date = toDateParam(filter_end_date) || start_date;
    // clear วันที่แล้วค้น: ถอยเป็น DEFAULT_RANGE_DAYS วันล่าสุด และอัปเดต picker ให้ตรงกับที่ค้นจริง
    if (!start_date) {
      start_date = daysAgo(DEFAULT_RANGE_DAYS - 1);
      end_date = today();
      this.setState({ filter_start_date: start_date, filter_end_date: end_date });
    }
    let result = await GET("v1/admin/log-systems", {
      page_size: PAGE_SIZE,
      page: page,
      start_date,
      end_date,
      service: filter_service,
      broker_uid: filter_broker,
      status_code: filter_status,
      data_search: filter_search,
      search_body: filter_search_body,
    });
    if (result?.status === true) {
      this.setState({
        data: result.data,
        count: result.pagination?.count || 0,
        page,
        loaded: true,
      });
    } else {
      this.setState({ data: [], count: 0, page: 1, loaded: true });
    }
    if (!silent) loading(false);
  };

  resetFilter = () => {
    this.setState(
      {
        filter_search: "",
        filter_search_body: false,
        filter_service: "",
        filter_start_date: today(),
        filter_end_date: today(),
        filter_broker: "",
        filter_status: "",
      },
      () => this.Get(1)
    );
  };

  openDetail = (item) => {
    this.setState({ modal_detail: true, detail: item, copied_key: "" });
  };

  closeDetail = () => {
    this.setState({ modal_detail: false });
  };

  copy = async (key, text) => {
    await copyText(text ?? "");
    if (this.copiedTimer) clearTimeout(this.copiedTimer);
    this.setState({ copied_key: key });
    this.copiedTimer = setTimeout(
      () => this.setState({ copied_key: "" }),
      COPIED_RESET_MS
    );
  };

  renderCopyButton = (key, text, className = "") => {
    const copied = this.state.copied_key === key;
    return (
      <span
        role="button"
        title="Copy"
        className={`pu-wh-copy-btn ${copied ? "copied" : "icon"} ${className}`}
        onClick={() => this.copy(key, text)}
      >
        {copied ? "Copied!" : ""}
      </span>
    );
  };

  renderDetail = () => {
    const item = this.state.detail;
    if (!item) return null;
    const pathText = item.path || "";
    const bodyText = prettyJson(item.request_body);
    const responseText = prettyJson(item.response_body);

    const row = (label, value) => (
      <div className="pu-kv pu-wh-kv">
        <span className="pu-kv-label">{label}</span>
        <span className="pu-kv-value text-break">{value}</span>
      </div>
    );
    const jsonBlock = (label, key, text) => (
      <div className="pu-wh-json">
        <div className="pu-wh-json-head">
          <span className="pu-wh-json-title">
            <span className="icon me-2">{""}</span>
            {label}
          </span>
          {this.renderCopyButton(key, text)}
        </div>
        <pre className="pu-wh-json-body">{text || "-"}</pre>
      </div>
    );

    return (
      <div className="row g-3">
        <div className="col-12 col-lg-5">
          <div className="pu-section h-100 mb-0">
            <div className="pu-section-title">
              <span className="icon">{""}</span>Summary
            </div>
            {row("DateTime", format_date(item.created_at, "dd/mm/yyyy hh:mm:ss", "en"))}
            {row("Service", serviceBadge(item.service))}
            {row(
              "Path",
              <span className="pu-wh-url">
                {pathText || "-"}
                {pathText && this.renderCopyButton("path", pathText, "ms-2")}
              </span>
            )}
            {row("User", getLogUser(item))}
            {row(
              "IP Address",
              item.ip_address ? <span className="pu-code">{item.ip_address}</span> : "-"
            )}
            {row("Status Code", statusBadge(item.status_code))}
            {row(
              "Time (ms)",
              <span className={`pu-wh-latency ${responseTimeClass(item.response_time_ms)}`}>
                {item.response_time_ms || 0} ms
              </span>
            )}
          </div>
        </div>
        <div className="col-12 col-lg-7">
          {jsonBlock("Body", "body", bodyText)}
          {jsonBlock("Response", "response", responseText)}
        </div>
      </div>
    );
  };

  render() {
    const {
      filter_search,
      filter_search_body,
      filter_service,
      filter_start_date,
      filter_end_date,
      filter_broker,
      filter_status,
      auto_refresh,
      page,
      data,
      data_broker,
      loaded,
      count,
      modal_detail,
      detail,
    } = this.state;
    const errorsOnPage = (data || []).filter(
      (item) => !isSuccessStatus(item.status_code)
    ).length;
    const activeTab = SERVICE_TABS.find((t) => t.key === filter_service);
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          {/* HERO */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Monitoring</div>
                <div className="ar-title">Logs Request</div>
                <div className="ar-subtitle">
                  Monitor system activity and performance
                </div>
              </div>
              <div className="pu-tabs pu-tabs-dark mb-0">
                {SERVICE_TABS.map((t) => (
                  <button
                    type="button"
                    key={t.key || "all"}
                    className={`pu-tab ${filter_service === t.key ? "active" : ""}`}
                    onClick={() =>
                      this.setState({ filter_service: t.key }, () => this.Get(1))
                    }
                  >
                    <span className="icon me-2">{SERVICE_ICONS[t.key] || ""}</span>
                    {t.label}
                  </button>
                ))}
              </div>
            </div>

            {/* FILTER */}
            <div className="ar-toolbar pu-om-filter mt-3">
              <div className="pu-om-filter-head">
                <span className="ar-toolbar-label">
                  <span className="icon me-2">{""}</span>Filter
                </span>
                <span className="ar-toolbar-hint">
                  Date range is required · max {MAX_RANGE_DAYS} days
                </span>
              </div>
              <div className="pu-om-filter-grid pu-wh-filter-grid">
                <div className="pu-om-field pu-om-field-search">
                  <span className="pu-om-field-label">
                    Search{filter_search_body ? " · including body" : ""}
                  </span>
                  <div className="pu-om-search">
                    <span className="icon pu-om-search-icon">{""}</span>
                    <input
                      type="text"
                      placeholder={
                        filter_search_body
                          ? "Path / user / body text..."
                          : "Path / user / IP..."
                      }
                      onChange={(e) => {
                        this.setState({ filter_search: e.target.value });
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          this.Get(1);
                        }
                      }}
                      value={filter_search}
                    />
                    <div className="pu-om-modes">
                      <button
                        type="button"
                        title="Search inside request/response body (slower)"
                        className={`pu-om-mode pu-lg-mode-text ${filter_search_body ? "active" : ""}`}
                        onClick={() =>
                          this.setState({ filter_search_body: !filter_search_body })
                        }
                      >
                        <span className="icon me-1">{""}</span>Body
                      </button>
                    </div>
                  </div>
                </div>
                <div className="pu-om-field pu-om-field-date">
                  <span className="pu-om-field-label">Date Range</span>
                  <DateRangePicker
                    className="form-control"
                    onChange={(e) => {
                      this.setState({
                        filter_start_date: e.start_date,
                        filter_end_date: e.end_date,
                      });
                    }}
                    value={{
                      start_date: filter_start_date,
                      end_date: filter_end_date,
                    }}
                    maxRangeDays={MAX_RANGE_DAYS}
                  />
                </div>
                <div className="pu-om-field">
                  <span className="pu-om-field-label">Broker</span>
                  <Select
                    className="form-control"
                    placeholder="All brokers"
                    options={data_broker}
                    value={filter_broker}
                    onChange={(v) => {
                      this.setState({ filter_broker: v });
                    }}
                    default={false}
                  />
                </div>
                <div className="pu-om-field">
                  <span className="pu-om-field-label">Status Code</span>
                  <Select
                    className="form-control"
                    placeholder="All status"
                    options={STATUS_OPTIONS}
                    value={filter_status}
                    onChange={(v) => {
                      this.setState({ filter_status: v });
                    }}
                    default={false}
                  />
                </div>
                <div className="ar-toolbar-actions pu-om-filter-actions">
                  <button
                    className="ar-btn-gold"
                    onClick={() => {
                      this.Get(1);
                    }}
                  >
                    <span className="icon me-2">{""}</span>Search
                  </button>
                  <button className="ar-btn-ghost" onClick={this.resetFilter}>
                    <span className="icon me-2">{""}</span>Reset
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* TABLE */}
          <div className="ar-table-card">
            <div className="ar-table-head flex-wrap gap-2">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{""}</span>
                  {activeTab && activeTab.key ? `${activeTab.label} requests` : "All requests"}
                </div>
                <div className="ar-table-caption">
                  {count > 0
                    ? `Showing ${(page - 1) * PAGE_SIZE + 1}–${Math.min(
                        page * PAGE_SIZE,
                        count
                      )} of ${count}`
                    : loaded
                      ? "No results"
                      : "Loading..."}
                  {errorsOnPage > 0 && (
                    <span className="ms-2">
                      &middot; <span className="pu-wh-failed-note">{errorsOnPage} error</span> on this page
                    </span>
                  )}
                </div>
              </div>
              <div className="d-flex align-items-center flex-wrap gap-2">
                <span className="ar-legend d-none d-lg-inline-flex align-items-center me-2">
                  <span className="pu-legend-swatch pu-wh-swatch-failed" />
                  Non-2xx response
                </span>
                <button
                  type="button"
                  className={`pu-om-ctl ${auto_refresh ? "active" : ""}`}
                  onClick={() => this.toggleAutoRefresh(!auto_refresh)}
                  title="Auto refresh every 30 seconds"
                >
                  <span className="icon me-1">{""}</span>
                  {auto_refresh ? "Auto 30s" : "Auto"}
                </button>
                <button
                  type="button"
                  className="pu-om-ctl"
                  onClick={() => this.Get(page)}
                  title="Refresh"
                >
                  <span className="icon me-1">{""}</span>Refresh
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover ar-table pu-table pu-lg-table">
                {/* every column sizes to its content; Path takes whatever is
                    left and truncates with an ellipsis (width:100% + max-width:0) */}
                <thead>
                  <tr>
                    <td className="text-nowrap">Time</td>
                    <td className="text-nowrap text-center">Service</td>
                    <td className="pu-lg-path-cell">Path</td>
                    <td className="text-nowrap">User</td>
                    <td className="text-nowrap">IP Address</td>
                    <td className="text-nowrap text-center">Status Code</td>
                    <td className="text-nowrap text-end">Time (ms)</td>
                    <td className="text-nowrap text-center">Actions</td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr
                      key={item.uid || `array-${index}`}
                      className={isSuccessStatus(item.status_code) ? "" : "pu-row-failed"}
                    >
                      <td data-label="Time" className="text-nowrap">
                        <span className="pu-mono">
                          {format_date(item.created_at, "dd/mm/yyyy hh:mm:ss", "en")}
                        </span>
                      </td>
                      <td data-label="Service" className="text-nowrap">
                        <div className="d-flex justify-content-center">
                          {serviceBadge(item.service)}
                        </div>
                      </td>
                      <td data-label="Path" className="pu-lg-path-cell">
                        <div className="pu-lg-path" title={item.path || ""}>
                          {item.path || <span className="pu-none">-</span>}
                        </div>
                      </td>
                      <td data-label="User" className="text-nowrap">
                        <span className="pu-name">{getLogUser(item)}</span>
                      </td>
                      <td data-label="IP Address" className="text-nowrap">
                        {item.ip_address ? (
                          <span className="pu-code">{item.ip_address}</span>
                        ) : (
                          <span className="pu-none">-</span>
                        )}
                      </td>
                      <td data-label="Status Code" className="text-nowrap text-center">
                        <div className="d-flex justify-content-center">
                          {statusBadge(item.status_code)}
                        </div>
                      </td>
                      <td data-label="Time (ms)" className="text-nowrap text-end">
                        <span className={`pu-wh-latency ${responseTimeClass(item.response_time_ms)}`}>
                          {item.response_time_ms || 0} ms
                        </span>
                      </td>
                      <td data-label="Actions" className="text-center">
                        <Dropdown align="end">
                          <Dropdown.Toggle className="pu-action-toggle" id={`log-actions-${index}`}>Action</Dropdown.Toggle>
                          <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                            <Dropdown.Item className="pu-action-item" onClick={() => this.openDetail(item)}>
                              <span className="icon">{""}</span>View
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                  {loaded && data?.length === 0 && (
                    <tr>
                      <td colSpan={8}>
                        <div className="ar-empty">
                          <span className="icon me-2">{""}</span>No logs in this range
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-3">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / PAGE_SIZE) || 1}
              page={page}
              showFirstButton
              showLastButton
              onChange={(_, p) => this.Get(p)}
            />
          </div>
        </div>

        {/* DETAIL */}
        <Modal
          show={modal_detail}
          onHide={this.closeDetail}
          size="xl"
          dialogClassName="pr-modal pr-scope pu-scope"
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Request</div>
              <h5 className="fw-bold mb-0">
                Logs Detail{" "}
                {detail?.status_code !== undefined && detail?.status_code !== null ? (
                  <span className="pu-currency-tag">{detail.status_code}</span>
                ) : null}
              </h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body pu-om-modal-body pb-3">
            {this.renderDetail()}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
